var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2L20.7549 5.43421L26.0942 5.43135L27.0186 10.69L31.1105 14.1198L28.4384 18.7423L29.3684 24L24.3501 25.8235L21.683 30.4488L16.6667 28.62L11.6504 30.4488L8.98321 25.8235L3.96496 24L4.89493 18.7423L2.22282 14.1198L6.31478 10.69L7.23911 5.43135L12.5784 5.43421L16.6667 2Z",
    fill: "#E7F1EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.3335L20.0883 4.7677L25.4275 4.76484L26.3519 10.0235L30.4438 13.4533L27.7717 18.0758L28.7017 23.3335L23.6834 25.1569L21.0163 29.7823L16 27.9535L10.9837 29.7823L8.31654 25.1569L3.29829 23.3335L4.22826 18.0758L1.55615 13.4533L5.6481 10.0235L6.57244 4.76484L11.9117 4.7677L16 1.3335Z",
    stroke: "#2D2926",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3949 16.4375H13.7229C13.8029 16.7415 13.8669 17.0455 13.8669 17.4135C13.8669 18.6135 13.0189 19.4295 12.1389 20.2455L13.2429 21.4615C13.8829 21.0935 14.3949 20.8695 15.0989 20.8695C16.0749 20.8695 16.3789 21.4615 17.5309 21.4615C18.6509 21.4615 19.4509 20.8535 20.1709 19.5895L18.7949 18.7255C18.3629 19.4615 18.0429 19.6215 17.6429 19.6215C16.8909 19.6215 16.6989 19.1415 15.9149 19.1415C15.3389 19.1415 14.7789 19.3815 14.3309 19.6535C15.0189 19.0615 15.6269 18.3735 15.6269 17.0455C15.6269 16.8215 15.6109 16.6295 15.5789 16.4375H17.7869V14.5815H15.0189C14.9389 14.2775 14.8909 13.9255 14.8909 13.4455C14.8909 12.3095 15.5949 11.8615 16.3149 11.8615C17.0829 11.8615 17.6269 12.2295 17.9789 12.9975L19.6269 12.2135C19.1469 10.8695 18.0109 10.0055 16.3149 10.0055C14.2349 10.0055 12.9069 11.4455 12.9069 13.3335C12.9069 13.7975 13.0349 14.2135 13.1629 14.5815H12.3949V16.4375Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountAmount);
export default __webpack_public_path__ + "static/media/discount-amount.999a005d15eb2218983ae7f6a85657fe.svg";
export { ForwardRef as ReactComponent };